import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';
import { blobToDataURL } from 'ShareableGraphics';
import angularModule from 'Users/angularModule/scripts/users_module';

const NATIVE_DOCUMENTS_DIR = 'private_user_documents';

angularModule.factory('PrivateUserDocumentsHelper', [
    '$injector',

    $injector => {
        const $window = $injector.get('$window');
        const $http = $injector.get('$http');
        const HttpQueue = $injector.get('HttpQueue');
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const TranslationHelper = $injector.get('TranslationHelper');
        const translationHelper = new TranslationHelper('users.private_user_documents_helper');

        // FIXME: Is this true about being unstable though?
        // Note: URL.createObjectURL is not yet considered stable but I used it anyway because it is
        // super convenient, works in all the major browsers (if you include the prefixed form), and this
        // is for admins only anyway.
        const createObjectURL = ($window.URL || $window.webkitURL || {}).createObjectURL || (() => {});
        const revokeObjectURL = ($window.URL || $window.webkitURL || {}).revokeObjectURL || (() => {});

        return {
            createObjectURL,
            revokeObjectURL,

            downloadDocument({ downloadUrl, fileContentType, fileFileName }, config = {}) {
                $http
                    .get(downloadUrl, {
                        responseType: 'arraybuffer',
                        ...config,
                    })
                    .then(response => {
                        const file = new Blob([response.data], {
                            type: fileContentType,
                        });
                        const new_url = createObjectURL(file);
                        const a = $window.document.createElement('a');
                        a.href = new_url;
                        a.download = fileFileName;
                        a.click();
                        revokeObjectURL(file);
                    })
                    .catch(response => {
                        HttpQueue.unfreezeAfterError(response.config);

                        if (response.status === 404) {
                            $window.alert(translationHelper.get('document_deleted'));
                        } else {
                            throw new Error(response);
                        }
                    });
            },

            viewDocument({ downloadUrl, fileContentType, fileFileName }) {
                return $http
                    .get(downloadUrl, {
                        responseType: 'arraybuffer',
                    })
                    .then(response => {
                        const file = new Blob([response.data], {
                            type: fileContentType,
                        });
                        if (Capacitor.isNativePlatform()) {
                            return this.openFileNatively(file, fileFileName || 'document', fileContentType);
                        }
                        NavigationHelperMixin.loadUrl(this.createObjectURL(file), '_blank');
                        return undefined;
                    });
            },

            // A blob: URL cannot leave the app WebView.
            async openFileNatively(file, fileFileName, fileContentType) {
                try {
                    // Remove the previous document, so that student documents do not collect on the device.
                    await Filesystem.rmdir({
                        path: NATIVE_DOCUMENTS_DIR,
                        directory: Directory.Cache,
                        recursive: true,
                    }).catch(() => {});
                    const dataUrl = await blobToDataURL(file);
                    const { uri } = await Filesystem.writeFile({
                        path: `${NATIVE_DOCUMENTS_DIR}/${fileFileName}`,
                        data: dataUrl.slice(dataUrl.indexOf(',') + 1),
                        directory: Directory.Cache,
                        recursive: true,
                    });
                    await FileOpener.openFile({ path: uri, mimeType: fileContentType });
                } catch (err) {
                    $injector.get('ErrorLogService').notify(err, undefined, {
                        level: 'warning',
                        fileContentType,
                    });
                    $window.alert(translationHelper.get('cannot_open_on_device'));
                }
            },
        };
    },
]);
